import React, { useState, useEffect, useRef } from "react";
import { log, warn, error } from "utils/logger";
import { setToken, setUserId, setUserFormData, setCurrentUser, getTransactionType, login } from "globals/auth";
import { setLoading, setNotification } from "globals/overlays";
import { sub, format, getDaysInMonth, parse, set } from "date-fns";
import { clearConfirmationData } from "globals/confirmation";
import { useDispatch, batch, useSelector } from "react-redux";
import Modal from "components/misc/Modal-V2";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import { Formik, Form, Field } from "formik";
import { AuthNetworkLayer } from "helpers";
import { useHistory } from "react-router";
import MaskedInput from "react-text-mask";
import { enUS } from "date-fns/locale";
import { object, string, boolean } from "yup";
// import Modal from "components/misc/Modal";
import jwtDecoder from "jwt-decode";
import AuthStyle from"./Auth.module.scss";
import "./Auth.scss";
// import { getNewGlobalToken } from "helpers/auth";
import { PAY_BALANCE } from "pages/RenewPolicy/constants";
// import { ErrorModal } from "components/misc/SweetModal";
import { ERROR } from "components/misc/Modal-V2/constants";
import { createUseStyles } from "react-jss";
import Calendar from "components/CustomDatePicker/Calandar/Calendar";
import InfoIcon from "components/misc/InfoIcon";
import { createLog } from "helpers/log";
import { fullLogout } from "globals/misc";
import FloatingLabelInput from "components/NewFloatingLabel/FloatingLabelInput";
import FloatingLabelSelect from "components/NewFloatingLabel/FloatingLabelSelect";
import CustomButton from "components/CustomButton";
import { clearQuoteCache } from "utils/quoteCache";
import { toast } from "react-toastify"; 
const { testIds } = require("testing/testIds");
const redirect = function () {
	window.open(`${process.env.REACT_APP_QUOTE_AND_BUY_BASE_URL}/get-started`, "_blank");
};

// import CustomDatePicker from "../CustomDatePicker";
const useStyles = createUseStyles({
	tabButtons: {
		"& button": {
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			width: "195px",
			maxWidth: "49.5%",
			minHeight: "30px",
			maxHeight: "40px",
			height: "40px",
			borderRadius: "50px",
			bottom: "-20px",
			border: "none",
			backgroundColor: "#CBE399",
			color: "#00A9E0",
			fontSize: "12px",
			fontWeight: "bold",
			padding: "10px 0",
			lineHeight: "12px",
			borderRadius: "10px",  
			"&:first-child": {},
			"&:last-child": {
				borderBottom: "none",
				borderLeft: "none",
			},
			"&:hover": {
				cursor: "pointer",
			},
			
		},
	},
	active: {
		background: "#00A9E0 !important",
		color: "white !important",
		"span": {
				alignSelf: "center"
			}
	},
	inactive: {
		backgroundColor: "#f1f5f9 !important",
		color: "#787e96 !important",
		"span": {
				alignSelf: "center"
			}
	},

	//Responsiveness for mobile
	"@media (max-width: 767px)": {
		tabButtons: {
			"& button": {
				width: "49%",
			},
		},
	},
});

const customStylesDate = {
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#002868" : state.isFocused ? "#adcdff" : "#f0f3f6",
		color: state.isSelected ? "#fff" : "#212529",
		fontWeight: "normal",
		padding: "0.5rem 1.3rem",
	}),
	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";
		const style = {
			borderStyle: "none",
			fontWeight: 400,
		};

		return { ...style, opacity, transition };
	},

	dropdownIndicator: (provided, state) => ({
		display: "none",
	}),
	indicatorSeparator: (provided, state) => ({
		...provided,
		visibility: "hidden",
	}),
	control: provided => ({
		...provided,
		color: "#212529",
		height: 33.3,
		// padding: "0 2rem",
		// paddingLeft: "0.5em",
		borderRadius: "10px",
		border: "1px solid #002868",
	}),
	placeholder: (provided, state) => ({
		fontWeight: 500,
		opacity: 0.5,
		fontSize: 12,
	}),
	menuList: (provided, state) => ({
		height: "250px",
		overflowY: "auto",
		paddingBottom: "4px",
		paddingTop: "4px",
		position: "relative",
		boxSizing: "border-box",
		minWidth: "100px",
	}),
};
const customStyles = {
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#002868" : state.isFocused ? "#adcdff" : "#fff",
		color: state.isSelected ? "#f0f3f6" : "#212529",
		fontWeight: "normal",
	}),
	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";
		const style = {
			borderStyle: "none",
			fontWeight: 800,
			fontSize: 13,
		};

		return { ...style, opacity, transition };
	},

	control: (provided, state) => ({
		...provided,
		color: "#212529",
		height: 35,
		// padding: "0.5rem 0.5rem",
		"@media (max-width: 767px)": {
			padding: 0,
			fontSize: 12,
		},
		borderRadius: 23,
		boxShadow:"none",
		border: "1px solid #BCBCBC",
		backgroundColor: "white",
		"@media (max-width: 768px)": {
			padding: "0",
			// paddingTop: "0.3rem",
			fontSize: 14,
		},
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		opacity: 1,
		fontSize: 12,
		display: "none",
		"@media (max-width: 767px)": {
			display: "none",
		},
	}),
	indicatorSeparator: (provided, state) => ({
		...provided,
		visibility: "hidden",
	}),

	placeholder: (provided, state) => ({
		fontWeight: 500,
		opacity: 0.5,
		fontSize: 12,
	}),
	menuList: (provided, state) => ({
		height: "100px",
		overflowY: "auto",
		paddingBottom: "4px",
		paddingTop: "4px",
		position: "relative",
		boxSizing: "border-box",
	}),
};
const customStylesNew = (error, value) => {
	return {
		option: (provided, state) => ({
			...provided,
			backgroundColor: state.isSelected ? "#00a9e0" : state.isFocused ? "#f0f3f6" : "white",
			color: state.isSelected ? "#f0f3f6" : "#212529",
			fontWeight: "normal",
		}),
		valueContainer: (provided, state) => {  
			const style = {
				padding: "2px 15px"
			};
			return { ...style, };
		},
		singleValue: (provided, state) => {
			const opacity = state.isDisabled ? 0.5 : 1;
			const transition = "opacity 300ms";
			const style = {
				borderStyle: "none",
				fontWeight: 400,
				fontSize: 12,
				paddingLeft: "15px",
				"&:active": {
				borderColor: "#004a8f",
			},
			};

			return { ...style, opacity, transition };
		},

		control: (provided, state) => ({
			...provided,
			color: "#212529",
			height: 48,
			// padding: "0.5rem 0.5rem",
			"@media (max-width: 767px)": {
				padding: 0,
				fontSize: 12,
			},
			borderRadius: 10,
			boxShadow:"none",
			background:"#f8fafc",
			border: `1px solid ${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,			
			"@media (max-width: 768px)": {
				padding: "0",
				// paddingTop: "0.3rem",
				fontSize: 12,
			}, 
			"&:hover": {
				borderColor: `${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,
			},
		}),
		dropdownIndicator: (provided, state) => ({
			...provided,
			opacity: 1,
			fontSize: 12,
			display: "none",
			"@media (max-width: 767px)": {
				display: "none",
			},
		}),
		indicatorSeparator: (provided, state) => ({
			...provided,
			visibility: "hidden",
		}),

		placeholder: (provided, state) => ({
			...provided,
			fontWeight: 500,
			opacity: 0.8,
			fontSize: 12,
			color: '#999',
			display: 'block',
		}),
		menuList: (provided, state) => ({
			height: "100px",
			overflowY: "auto",
			paddingBottom: "4px",
			paddingTop: "4px",
			position: "relative",
			boxSizing: "border-box",
		}),
	}
};
const customStylesLeft = (error, value) => {
	return {
		option: (provided, state) => ({
			...provided,
			backgroundColor: state.isSelected ? "#00a9e0" : state.isFocused ? "#f0f3f6" : "white", 
			color: state.isSelected ? "#f0f3f6" : "#212529",
			fontWeight: "normal",
		}),
		valueContainer: (provided, state) => {  
			const style = {
				padding: "2px 15px"
			};
			return { ...style, };
		},
		singleValue: (provided, state) => {
			const opacity = state.isDisabled ? 0.5 : 1;
			const transition = "opacity 300ms";
			const style = {
				borderStyle: "none",
				fontWeight: 400,
				fontSize: 12,
				paddingLeft: "15px",
			};

			return { ...style, opacity, transition };
		},

		control: (provided, state) => ({
			...provided,
			color: "#212529",
			height: 48,
			// padding: "0.5rem 0.5rem",
			"@media (max-width: 767px)": {
				padding: 0,
				fontSize: 12,
			},
			boxShadow:"none",
			borderRadius: "10px", 
			border: `1px solid ${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,			
			background:"#f8fafc",
			"@media (max-width: 768px)": {
				padding: "0",
				// paddingTop: "0.3rem",
				fontSize: 12,
			},
			"&:hover": {
				borderColor: `${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,
			},
		}),
		dropdownIndicator: (provided, state) => ({
			...provided,
			opacity: 1,
			fontSize: 12,
			display: "none",
			"@media (max-width: 767px)": {
				display: "none",
			},
		}),
		indicatorSeparator: (provided, state) => ({
			...provided,
			visibility: "hidden",
		}),

		placeholder: (provided, state) => ({
			...provided,
			fontWeight: 500,
			opacity: 0.8,
			fontSize: 12,
			color: '#999',
			display: 'block',
		}),
		menuList: (provided, state) => ({
			height: "100px",
			overflowY: "auto",
			paddingBottom: "4px",
			paddingTop: "4px",
			position: "relative",
			boxSizing: "border-box",
		})
	}
};
const customStylesRight = (error, value) => {
	return {
		option: (provided, state) => ({
			...provided,
			backgroundColor: state.isSelected ? "#00a9e0" : state.isFocused ? "#f0f3f6" : "white",
			color: state.isSelected ? "#f0f3f6" : "#212529",
			fontWeight: "normal",
		}),
		valueContainer: (provided, state) => {  
			const style = {
				padding: "2px 15px"
			};
			return { ...style, };
		},
		singleValue: (provided, state) => {
			const opacity = state.isDisabled ? 0.5 : 1;
			const transition = "opacity 300ms";
			const style = {
				paddingLeft: "15px",
				borderStyle: "none",
				fontWeight: 400,
				fontSize: 12,
			};

			return { ...style, opacity, transition };
		},

		control: (provided, state) => ({
			...provided,
			color: "#212529",
			height: 48,
			boxShadow:"none",
			// padding: "0.5rem 0.5rem",
			"@media (max-width: 767px)": {
				padding: 0,
				fontSize: 12,
			},
			borderRadius: "10px",
			border: `1px solid ${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,			
			background:"#f8fafc",
			"@media (max-width: 768px)": {
				padding: "0",
				// paddingTop: "0.3rem",
				fontSize: 12,
			},
			"&:hover": {
				borderColor: `${value && !error ? "#00a9e0" : error ? "#FF0000" : "#d4d4d4" }`,
			},
		}),
		dropdownIndicator: (provided, state) => ({
			...provided,
			opacity: 1,
			fontSize: 12,
			display: "none",
			"@media (max-width: 767px)": {
				display: "none",
			},
		}),
		indicatorSeparator: (provided, state) => ({
			...provided,
			visibility: "hidden",
		}),

		placeholder: (provided, state) => ({
			...provided,
			fontWeight: 500,
			opacity: 0.8,
			fontSize: 12,
			color: '#999',
			display: 'block',
		}),
		menuList: (provided, state) => ({
			height: "100px",
			overflowY: "auto",
			paddingBottom: "4px",
			paddingTop: "4px",
			position: "relative",
			boxSizing: "border-box",
		})
	}
};

//Generating a list of years for year selection
const now = new Date();
const thisYear = now.getFullYear();
const old = sub(now, { years: 100 });
const oldYear = old.getFullYear();
const years = Array(thisYear - oldYear)
	.fill("")
	.map((_, i) => {
		return { value: thisYear - i, label: thisYear - i };
	});
const monthArray = [];
for (let i = 0; i < 12; i++) {
	monthArray.push(enUS.localize.month(i));
}
const months = monthArray.map((month, i) => {
	return { value: (i + 1).toString().padStart(2, "0"), label: month.slice(0, 3).toUpperCase() };
});
const dayDefault = Array(31)
	.fill("")
	.map((_, i) => {
		const day = (i + 1).toString().padStart(2, "0");
		return { value: day, label: day };
	});

const genders = [
	{ value: "Male", name: "Male" },
	{ value: "Female", name: "Female" },
];

const defaultRegisterValues = {
	dobDay: "",
	dobMonth: "",
	dobYear: "",
	trn: "",
	companyTRN: "",
	gender: "",
	companyName: "",
	isIndividual: true,
};

const authFormSchema = object().shape({
	dobDay: string().when("isIndividual", {
		is: true,
		//then: string().required("Please choose a valid day"),
		then: string().required("Invalid day"),
	}),
	dobMonth: string().when("isIndividual", {
		is: true,
		//then: string().required("Please choose a valid month"),
		then: string().required("Invalid month"),
	}),
	dobYear: string().when("isIndividual", {
		is: true,
		//then: string().required("Please choose a valid year"),
		then: string().required("Invalid year"),
	}),
	trn: string().when("isIndividual", {
		is: true,
		then: string()
			.required("Please enter a valid TRN")
			.matches(/^[\d]{3}-[\d]{3}-[\d]{3}$/, "Please enter a valid TRN"),
	}),
	companyTRN: string().when("isIndividual", {
		is: false,
		then: string()
			.required("Please enter a valid TRN")
			.matches(/^[\d]{3}-[\d]{3}-[\d]{3}$/, "Please enter a valid TRN"),
	}),

	gender: string().when("isIndividual", {
		is: true,
		then: string().required("Please choose a gender"),
	}),
	isIndividual: boolean(),
	companyName: string().when("isIndividual", {
		is: false,
		then: string().required("Company Name is required"),
		otherwise: string(),
	}),
});

const TRNMask = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

/** Persist the Auth that lives across refresh */
export default function Auth({
	match,
	isClaims = false,
	isTrackAClaim = false,
	isPayBalance = false,
	isPolicyManager = false,
	generatingNewToken,
}) {
	const dispatch = useDispatch();
	const formikRef = useRef();
	const history = useHistory();
	const classes = useStyles();
	const transactionType = useSelector(getTransactionType);
	const [tab, setTab] = useState(match.url.split("/").pop());
	const [isIndividual, setIsIndividual] = useState(true);
	const [open, openModal] = useState(false);
	const [days, setDays] = useState(dayDefault);
	const [remoteServerError, setRemoteServerError] = useState(false);

	//dispatch(fullLogout());
	const closeModal = () => {
		openModal(false);
	};

	useEffect(() => { return () => {}; }, []);

	const currentTime = new Date();
	useEffect(() => {
		setTab(match.url.split("/").pop());
	}, [match.url]);
	let dob;
	const handleFormSubmit = async formValues => {
		dispatch(setLoading(true));
		setIsIndividual(formValues.isIndividual);
		if (formValues.isIndividual) {
			dob = format(
				parse(`${formValues.dobYear} ${formValues.dobMonth} ${formValues.dobDay}`, "yyyy MM dd", new Date()),
				"yyyy-MM-dd"
			);
		}

		/** Pull data from form to be sent for authentication */
		const userData = {
			dob: dob,
			is_a_company: !formValues.isIndividual,
			national_id: formValues.isIndividual ? formValues.trn.replace(/-/g, "") : formValues.companyTRN.replace(/-/g, ""),
			national_id_type: "TRN",
			gender: formValues.gender,
			company_name: formValues.isIndividual ? "" : formValues.companyName.trim(),
		};

		dispatch(setUserFormData(userData));

		try {
			/**
			 * Special-case: tokenized Manage-Your-Policy login
			 * URL shape: /manage-your-policy/login?t=<JWT>
			 * JWT contains: policy_number, policy_id, policy_prefix, global_name_id, national_id, dob, gender, names...
			 */
			const search = window.location.search || "";
			const hasTokenizedManageLogin = window.location.pathname.includes("/manage-your-policy/login") && search.includes("t=");
			let shouldForwardToken = false;
			if (hasTokenizedManageLogin) {
				const params = new URLSearchParams(search);
				const tokenParam = params.get("t");
				try {
					const decodedToken = jwtDecoder(tokenParam || "");
					const normalizedForm = {
						national_id: (formValues.isIndividual ? formValues.trn : formValues.companyTRN || "").replace(/-/g, ""),
						dob,
						gender: formValues.gender,
					};
					let normalizedTokenDob = decodedToken?.dob || "";
					try {
						if (normalizedTokenDob && normalizedTokenDob.includes("/")) {
							normalizedTokenDob = format(parse(normalizedTokenDob, "MM/dd/yyyy", new Date()), "yyyy-MM-dd");
						}
					} catch (error) {
						// Ignore date parsing errors and continue with original value
						warn("Date parsing failed, using original value:", error);
					}
					const normalizedToken = {
						national_id: (decodedToken?.national_id || "").replace(/-/g, ""),
						dob: normalizedTokenDob,
						gender: decodedToken?.gender,
					};
					const matchesId = normalizedForm.national_id && normalizedForm.national_id === normalizedToken.national_id;
					const matchesDob = normalizedForm.dob && normalizedToken.dob && normalizedForm.dob === normalizedToken.dob;
					const matchesGender = normalizedForm.gender && normalizedToken.gender && normalizedForm.gender === normalizedToken.gender;
					log("matchesId", matchesId);
					log("matchesDob", matchesDob);
					log("matchesGender", matchesGender);
					if (!matchesId || !matchesDob || !matchesGender) {
						dispatch(setLoading(false));
						toast.error("The information entered does not match your secure link. Please verify your details and try again.");
						return;
					}
					shouldForwardToken = true;
				} catch (e) {
					error("error", e);
					dispatch(setLoading(false));
					toast.error("We couldn't validate your secure link. Please request a new link or try again later.");
					return;
				}
			}
			/** Remove any leftover data */
			dispatch(clearConfirmationData());
			/** Try to acquire token for user */
			generatingNewToken.current = true;
			// const loginRequest = await getNewGlobalToken(3);
			// if (!loginRequest.token) throw new Error("Failed to acquire token");

			/** Try to acquire global name id for future requests */
			const globalNameIdRequest = await AuthNetworkLayer.getGlobalNameId(userData);

			if (globalNameIdRequest.IsMethodCallSuccessful === false) {
				setRemoteServerError(true);
			} else if (!globalNameIdRequest.success) {
				setRemoteServerError(false);
				throw new Error("Failed to get global name ID");
			}

			/** Try to acquire encoded user data for future requests */
			const otpMethodsResponse = await AuthNetworkLayer.getUserData(userData, globalNameIdRequest.global_name_id);
			/**
			 * Verify token signature
			 * @type {*}
			 */

			clearQuoteCache();
			const otpMethods = jwtDecoder(otpMethodsResponse.result);
			if (!otpMethods.success) throw new Error("Failed to acquire options for OTP verification");

			batch(() => {
				dispatch(setToken(otpMethodsResponse.result));
				dispatch(setUserId(globalNameIdRequest.global_name_id));
				dispatch(
					setCurrentUser({
						phone_numbers: otpMethods.phone_numbers,
						email_address: otpMethods.email_address,
						first_name: otpMethods.first_name,
						last_name: otpMethods?.last_name,
						mother_maiden_name: otpMethods?.mother_maiden_name,
					})
				);
				dispatch(setLoading(false));
			});

			generatingNewToken.current = false;

			if (isClaims) {
				history.replace(`/claims/otp`);
			} else if (transactionType === PAY_BALANCE) {
				history.replace(`/${PAY_BALANCE}/otp`);
			} else if (isTrackAClaim) {
				history.replace(`/track-my-claim/otp`);
			} else if (isPayBalance) {
				history.push("/paybalance/otp");
			} else if (isPolicyManager) {
				history.push(shouldForwardToken ? `/manage-your-policy/otp${search}` : "/manage-your-policy/otp");
			} else {
				history.replace(`/renewal/otp`);
			}
		} catch (e) {
			if (e.message === "Unable to connect to the remote server" || e.message.match(/error/i)) {
				setRemoteServerError(true);
			}
			openModal(true);
		} finally {
			dispatch(setLoading(false));
			generatingNewToken.current = false;
			createLog({
				trn: formValues.isIndividual ? formValues.trn.replace(/-/g, "") : formValues.companyTRN.replace(/-/g, ""),
				type: `${transactionType}-Login`,
				data: { ...formValues },
				errors: {
					message: open
						? remoteServerError
							? "Server error has occurred"
							: "Could not find a record in our database"
						: "",
				},
			});
		}
	};

	/**
	 * Checks whether the submit button should be disabled
	 * @param {defaultRegisterValues} values
	 */
	function shouldDisableSubmit(values, errors) {
		//If isIndividual do not check for company name and trn
		if (values.isIndividual) {
			return (
				Object.entries(errors).length !== 0 ||
				!values.dobMonth ||
				!values.dobDay ||
				!values.dobYear ||
				!values.trn ||
				!values.gender
			);
		} else {
			return !values.companyName || !values.companyTRN || Object.entries(errors).length !== 0;
		}
	}

	/**
	 * Custom handler for DOB fields
	 * @param {*} e
	 * @param {*} f
	 * @param {*} values
	 * @param {*} setFieldValue
	 */
	function handleDOBChange(e, f, values, setFieldValue) {
		let daysInMonth = 31;

		if ((f.name === "dobMonth" && values.dobYear.length > 0) || (f.name === "dobYear" && values.dobMonth.length > 0)) {
			daysInMonth = getDaysInMonth(
				parse(
					`${f.name === "dobYear" ? e.value : values.dobYear} ${f.name === "dobMonth" ? e.value : values.dobMonth}`,
					"yyyy MM",
					new Date()
				)
			);
			setDays(
				Array.from(Array(daysInMonth), (_, i) => {
					const day = (i + 1).toString().padStart(2, "0");
					return { value: day, label: day };
				})
			);
		}

		//Reset day (when other values changed) or (when days in month is less than selection)
		if (f.name !== "dobDay" && parseInt(values.dobDay) > daysInMonth) setFieldValue("dobDay", "");

		setFieldValue(f.name, (f.name === "dobMonth" || f.name === "dobDay") ? e.value.toString().padStart(2, "0") : e.value.toString());
	}

	const updateDay = newDay => {
		// if (newDay !== undefined && newDay != "") setDay(newDay);
	};

	const updateMonth = newMonth => {
		// if (newMonth !== undefined && newMonth != "") setMonth(newMonth);
	};

	const updateYear = newYear => {
		// if (newYear !== undefined && newYear != "") setYear(newYear);
	};
	const daysInMonth = (month, year) => {
		if (month === currentTime.getMonth() + 1 && year === currentTime.getFullYear()) {
			return currentTime.getDate();
		}
		return new Date(year, month, 0).getDate();
	};

	const getSelectedDate = (selectedDate, setFieldValue, values) => {
		if (selectedDate !== undefined) selectedDate = new Date(selectedDate);
		let day = selectedDate.getDate() + 1;
		let month = selectedDate.getMonth() + 1;
		let year = selectedDate.getFullYear();
		let daysAmount = daysInMonth(month, year);

		if (day === 32) {
			day = 1;

			if (month === 12) {
				month = 1;
				year++;
			} else {
				month++;
			}
		} else if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
			day = 1;
			month++;
		} else if (month === 2) {
			var isLeap = new Date(parseInt(year), 1, 29).getMonth() === 1;

			if (!isLeap && day === 29) {
				day = 1;
				month++;
			}
		} 

		handleDOBChange({ value: day }, { name: "dobDay" }, values, setFieldValue);
		handleDOBChange({ value: month }, { name: "dobMonth" }, values, setFieldValue);
		handleDOBChange({ value: year }, { name: "dobYear" }, values, setFieldValue);

		const returnDaysAmountArray = (daysAmount = 31) => {
			return Array(daysAmount)
				.fill("")
				.map((_, i) => {
					return {
						value: (i + 1).toString().padStart(2, "0"),
						label: (i + 1).toString().padStart(2, "0"),
					};
				});
		};

		let daysArray = returnDaysAmountArray(daysAmount);
		setDays(daysArray);
	};

	return (
		<div  
			className={`${AuthStyle["auth-container"]} ${AuthStyle["constrain-small"]}`}
			data-testid={testIds.auth.login.page.container}
		>
			{/* <Modal
				modalType={ERROR}
				open={open}
				title="Unable to Login"
				content={
					remoteServerError ? (
						<div>It's not you, It's us. Please retry later or contact us at (888) 687-2442.</div>
					) : (
						<div>
							{isIndividual
								? "Oops! Something's not right. There was an issue authenticating you with the information provided. Please verify the information used."
								: "Oops! Something's not right. We could not find a record in our database. Please ensure that the company's name matches your insurance document"}
						</div>
					)
				}
				primaryLabel="Ok"
				primaryCallback={closeModal}
			/> */}
			<Modal
				modalType = {ERROR}
				showModal={open}
				closeModal={() => closeModal()}
				title={"Unable to Login"} 
				primaryLabel="Ok"
				primaryCallback={closeModal}
			> 
				<div>
					{
						remoteServerError ? (
							<div>It's not you, It's us. Please retry later or contact us at (888) 687-2442.</div>
						) : (
							<div>
								{isIndividual
									? "Oops! Something's not right. There was an issue authenticating you with the information provided. Please verify the information used."
									: "Oops! Something's not right. We could not find a record in our database. Please ensure that the company's name matches your insurance document"}
							</div>
						)
					}
				</div>
			</Modal> 

			<Formik
				innerRef={formikRef}
				initialValues={defaultRegisterValues}
				validationSchema={authFormSchema}
				onSubmit={handleFormSubmit}
			>
				{({
					isSubmitting,
					errors,
					values,
					touched,
					setFieldValue,
					setFieldTouched,
					handleBlur,
					validateField,
					resetForm,
				}) => (
					<Form  
						className={`${AuthStyle["auth-content"]}`}
						style={{ marginTop: "2px" }}
						data-testid={testIds.auth.login.form.container}
					>
						{/* Tab buttons to toggle between Individual and Company */}

						{tab === "login" && (
							<> 
								<Row
									className={`${AuthStyle["form"]} ${AuthStyle["signup"]} m-0`} 
								>
									<div className={`${AuthStyle["content-title-container"]}`} >
										<h1  
											className={`${AuthStyle["content-title"]}`} 
										>
											{" "}
											Welcome!
										</h1>
										<div className="instruction">Please enter your details to continue.</div>
									</div>
									<div
										style={{
											marginBottom: "5px",
											gap: "0",
											display: "flex",
											position: "relative", 
											zIndex: 0,
											background:"#f1f5f9",
											borderRadius: "8px",
											justifyContent: "space-between",
											height: "fit-content",
											width: "100%"
										}}
										className={classes.tabButtons}
									>
										<button 
											type="button" 
											className={values.isIndividual ? classes.active : classes.inactive}
											data-testid={testIds.auth.login.actions.individualTabButton}
											onClick={() => {
												// resetForm();
												setFieldValue("isIndividual", true);
											}}
										>
											<span style={{alignSelf:"center"}}>Individual</span>
										</button>
										<button 
											type="button"
											className={!values.isIndividual ? classes.active : classes.inactive}
											data-testid={testIds.auth.login.actions.corporateTabButton}
											onClick={() => {
												// resetForm();
												setFieldValue("isIndividual", false);
											}}
										>
											<span style={{alignSelf:"center"}}>Corporate</span>
										</button>
									</div>
									{values.isIndividual ? (
										<>
											<Col style={{marginTop: "15px", padding:"0"}} lg={12} md={12} sm={12} xs={12}>
												<label
													className={`
														${AuthStyle["form-label-login"]}
														${AuthStyle[values.gender ? " hasValue" : ""]}
														${AuthStyle[touched.gender && errors.gender ? " hasError" : ""]} 
													`}   
													style={{height: "70px"}}
												>
													<div
														style={{
															position:"relative"
														}}
													>
														<FloatingLabelInput
															as="input"
															id="trn" 
															data-testid={testIds.auth.login.form.trnInput}
															className={`${AuthStyle["outlined-input"]}`}
															mask={TRNMask}
															inputType="mask"
															guide={false}
															maxLength={11}
															label={
																<div style={{ whiteSpace: "nowrap" }}>
																	<span className={`${AuthStyle["field-title"]}`} >TRN</span>
																	<span className={`${AuthStyle["required"]}`} > * </span> 
																</div> 
															}
															value={values.trn}
															onChange={e => {
																const rawValue = e.target.value;
																setFieldValue("trn", e.target.value);

																// If MaskedInput provides the unmasked value differently, check its docs.
																// Sometimes it's e.value or a different property if it's not a standard input event.
																// For 'react-text-mask', the raw value is usually e.target.value.

																setFieldValue("trn", rawValue); 
															}}
															onBlur={e => {
																// It's good practice to also touch the field for validation to run on change
																// if desired, though onBlur usually handles this.
																setFieldTouched("trn", true, true); // true for touched, true to run validation
															}}
															type="text"
															placeholder="9 Digits"
															error={errors.trn} 
															showErrorMessage={false}
															touched={touched.trn} 
															required
														/> 
														<svg style={{ position:"absolute", width: "16px", right: "0", top: "calc(24px - 8px)", margin: "0 10px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H12H17C18.8856 5 19.8284 5 20.4142 5.58579C21 6.17157 21 7.11438 21 9V12V15C21 16.8856 21 17.8284 20.4142 18.4142C19.8284 19 18.8856 19 17 19H12H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V12V9Z" stroke="#93a2b8" stroke-width="2" stroke-linejoin="round"></path> <path d="M9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10Z" stroke="#93a2b8" stroke-width="2"></path> <path d="M11.6521 15C11.1982 14.2388 10.3888 14 9.00001 14C8.11946 14 7 14 7 14" stroke="#93a2b8" stroke-width="2" stroke-linecap="round"></path> <path d="M12 9L17 9" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13 12L17 12" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M15 15H17" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
													</div>
												</label>
											</Col>

											<Col style={{marginBottom: "20px", padding:"0"}} lg={{ size: 12 }}>
												<Row className={`${AuthStyle["dob-wrapper"]} mb-md-0`} >
													<Col lg={12} style={{ position: "relative" }}>
														<div
															className={`
																${AuthStyle["fieldset-labelNew"]} mb-3 
																${values.dobMonth || values.dobYear || values.dobDay ? AuthStyle["hasValue"] : ""}
																${
																	(touched.dobYear && errors.dobYear) ||
																	(touched.dobDay && errors.dobDay) ||
																	(touched.dobMonth && errors.dobMonth)
																		? AuthStyle["hasError"]
																		: ""
																}
															`} 
														>
															<span className={`
																${AuthStyle["field-title"]}
																${AuthStyle["login-title"]} `}
																style={{
																	color:"#0064a5"
																}} 
																>
																	{"Date of Birth"}
															</span>
															<span
																className={`
																	${AuthStyle["required"]} 
																`}>*</span>
														</div>
													</Col>

													{/* <div className="fieldset-row"> */}
													<div
													style={{
														display:"grid", 
														gridTemplateColumns: "1fr 1fr 1fr",
														width: "100%",
														padding: "0 15px", 
														gap: "10px"
													}}
													>
														<div data-testid={testIds.auth.login.form.dobMonthSelect}>
															<label className={`${AuthStyle["dob-field"]}`}>
																<Field name="dobMonth" className={`${AuthStyle["fieldNew"]}`}>
																	{({ field }) => (
																		<Select
																			{...field}
																			inputId="auth-login-dob-month"
																			value={
																				values.dobMonth
																					? { value: values.dobMonth, label: months[values.dobMonth - 1].label }
																					: null
																			}
																			placeholder="MM"
																			options={months}
																			blurInputOnSelect 
																			styles={customStylesLeft(touched.dobMonth && errors.dobMonth, values.dobMonth)}
																			classNamePrefix="react-select" 
																			className={
																				"react-select-container" +
																				`${values.dobMonth ? " hasValue" : ""}` +
																				`${touched.dobMonth && errors.dobMonth ? " hasError" : ""}`
																			}
																			onBlur={() => {
																				setFieldTouched("dobMonth", true, false);
																				validateField("dobMonth");
																			}}
																			onChange={(e, f) => handleDOBChange(e, f, values, setFieldValue)}
																		/>
																	)}
																</Field>
																{/* {touched.dobMonth && errors.dobMonth && <div className="error">{errors.dobMonth}</div>} */}
															</label>
														</div>
														<div data-testid={testIds.auth.login.form.dobDaySelect}>
															{" "}
															<label className={`${AuthStyle["dob-field"]}`}>
																<Field name="dobDay" className={`${AuthStyle["fieldNew"]}`}>
																	{({ field }) => (
																		<Select
																			{...field}
																			inputId="auth-login-dob-day"
																			options={days}
																			value={values.dobDay ? { value: values.dobDay, label: values.dobDay } : null}
																			placeholder="DD"
																			blurInputOnSelect
																			styles={customStylesNew(touched.dobDay && errors.dobDay, values.dobDay)}
																			classNamePrefix="react-select"
																			className={
																				"react-select-container" +
																				`${values.dobDay ? " hasValue" : ""}` +
																				`${touched.dobDay && errors.dobDay ? " hasError" : ""}`
																			}
																			onBlur={() => {
																				setFieldTouched("dobDay", true, false);
																				validateField("dobDay");
																			}}
																			noOptionsMessage={() => "Please choose a year and month first"}
																			onChange={(e, f) => handleDOBChange(e, f, values, setFieldValue)}
																		/>
																	)}
																</Field>
																{/* {touched.dobDay && errors.dobDay && <div className="error">{errors.dobDay}</div>} */}
															</label>
														</div>
														<div data-testid={testIds.auth.login.form.dobYearSelect}>
															<label className={`${AuthStyle["dob-field"]}`} >
																<Field name="dobYear" className={`${AuthStyle["fieldNew"]}`} >
																	{({ field }) => (
																		<div
																			style={{
																				position:"relative"
																			}}
																		>
																			<Select
																				{...field}
																				inputId="auth-login-dob-year"
																				value={values.dobYear ? { value: values.dobYear, label: values.dobYear } : null}
																				options={years}
																				blurInputOnSelect
																				placeholder="YYYY" 
																				styles={customStylesRight(touched.dobYear && errors.dobYear, values.dobYear)}
																				classNamePrefix="react-select"
																				className={
																					"react-select-container" +
																					`${values.dobYear ? " hasValue" : ""}` +
																					`${touched.dobYear && errors.dobYear ? " hasError" : ""}`
																				}
																				onBlur={() => {
																					setFieldTouched("dobYear", true, false);
																					validateField("dobYear");
																				}}
																				onChange={(e, f) => handleDOBChange(e, f, values, setFieldValue)}
																			/> 	
																			<svg style={{ position:"absolute", width: "16px", right: "0", top: "calc(50% - 8px)", margin: "0 10px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 9H21M17 13.0014L7 13M10.3333 17.0005L7 17M7 3V5M17 3V5M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
																		</div>
																	)} 
																</Field>
																{/* {touched.dobYear && errors.dobYear && <div className="error">{errors.dobYear}</div>} */}
															</label>
														</div>
													</div> 
												</Row>
												{/* {(touched.dobYear && errors.dobYear) ||
												(touched.dobDay && errors.dobDay) ||
												(touched.dobMonth && errors.dobMonth) ? (
													<div
														className=""
														style={{
															fontSize: "12px",
															color: "red",
															lineHeight: "12px",
															marginTop: "8px",
															position:"absolute"
														}}
													>
														Please enter a valid Date
													</div>
												) : null} */}
											</Col>

											<Col style={{margin: "0px", padding:"0"}} lg={12} md={12} sm={12} xs={12}>
												{" "}
												<label
													className={`
														${AuthStyle["form-label-login"]}
														${AuthStyle[values.gender ? " hasValue" : ""]}
														${AuthStyle[touched.gender && errors.gender ? " hasError" : ""]} 
													`}   
												>
													<div>
														{/* <span className="field-title login-title">{"Gender "}</span>
														<span className="required">*</span> */}
													</div>
													<FloatingLabelSelect
														id="gender"
														name="gender"
														label={
															<div style={{ whiteSpace: "nowrap" }}>
															<span className={AuthStyle["field-title"]}>Gender</span>
															<span className={AuthStyle["required"]}> * </span>
															</div>
														}
														options={genders}
														value={genders.find(option => option.value === values.gender) || null}
														onBlur={() => setFieldTouched("gender", true, false)}
														getOptionLabel={option => option?.name}
														getOptionValue={option => option?.value}
														onChange={option => {
															setFieldValue("gender", option?.value || "", true);
															setFieldTouched("gender", true, false);
														}}
														error={errors.gender}
														showErrorMessage={false}
														touched={touched.gender}
													/>
													{/* <Field name="gender" className="fieldNew">
														{({ field }) => (
															<Select
																{...field}
																value={values.gender ? { value: values.gender, label: values.gender } : null}
																options={genders}
																blurInputOnSelect
																isSearchable={true}
																styles={customStyles}
																classNamePrefix="react-select"
																className={
																	"field react-select-container" +
																	`${values.gender ? " hasValue" : ""}` +
																	`${touched.gender && errors.gender ? " hasError" : ""}`
																}
																onBlur={() => {
																	setFieldTouched("gender", true, false);
																	validateField("gender");
																}}
																onChange={e =>
																	// @ts-ignore
																	setFieldValue(field.name, e.value)
																}
															/>
														)}
													</Field> */}
													{/* {touched.gender && errors.gender && 
													<div  
														className={`${AuthStyle["error"]}`}  
													>
														{errors.gender}
													</div>} */}
												</label>
											</Col>
										</>
									) : (
										<>
											{/* Two Columns one for Company Name and One for TRN */}
											<Col style={{marginBottom: "0", marginTop: "10px", padding:"0"}} lg={12} md={12} sm={12} xs={12}> 
												<label
													className={`
														${AuthStyle["form-label-login"]}
														${AuthStyle[values.gender ? " hasValue" : ""]}
														${AuthStyle[touched.gender && errors.gender ? " hasError" : ""]} 
													`}   
												>
													<FloatingLabelInput
														as="input"
														id="companyName"
														type="text"
														data-testid={testIds.auth.login.form.companyNameInput}
														className="outlined-input"
														value={values.companyName}
														onChange={e => setFieldValue("companyName", e.target.value)}
														onBlur={handleBlur}
														label={
															<div style={{ whiteSpace: "nowrap" }}>
																<span className={`${AuthStyle["field-title"]}`} >Company Name</span>
																<span className={`${AuthStyle["required"]}`} > * </span> 
															</div>   
														}
														error={errors.companyName} 
														showErrorMessage={false}
														touched={touched.companyName} 
													/> 
												</label>
											</Col>
											<Col style={{marginBottom: "0", padding:"0"}} lg={12} md={12} sm={12} xs={12}>
												<label
													className={`
														${AuthStyle["form-label-login"]}
														${AuthStyle[values.gender ? " hasValue" : ""]}
														${AuthStyle[touched.gender && errors.gender ? " hasError" : ""]} 
													`}   
													data-testid={testIds.auth.login.form.genderSelect}
												>
													<div>
														{/* <span className="field-title login-title">{"TRN "}</span>
														<span className="required">*</span> */}
													</div>
													<div style={{ position:"relative" }}>
														<FloatingLabelInput
															as="input"
															id="comapnyTRN"
															type="text"
															data-testid={testIds.auth.login.form.companyTrnInput}
															inputType="mask"
															className={`${AuthStyle["outlined-input"]}`}
															guide={false}
															mask={TRNMask}
															value={values.companyTrn}
															onChange={e => setFieldValue("companyTRN", e.target.value)}
															maxLength={11}
															onBlur={ e => {
																handleBlur(e)
																setFieldTouched("companyTRN", true, true);
															}}
															required
															label={
																<div style={{ whiteSpace: "nowrap" }}>
																	<span className={`${AuthStyle["field-title"]}`}>TRN</span>
																	<span className={`${AuthStyle["required"]}`}> * </span> 
																</div>   
															}
															showErrorMessage={false}
															error={errors.companyTRN} 
															touched={touched.companyTRN} 
														/> 
														<svg style={{ position:"absolute", width: "16px", right: "0", top: "calc(24px - 8px)", margin: "0 10px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H12H17C18.8856 5 19.8284 5 20.4142 5.58579C21 6.17157 21 7.11438 21 9V12V15C21 16.8856 21 17.8284 20.4142 18.4142C19.8284 19 18.8856 19 17 19H12H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V12V9Z" stroke="#93a2b8" stroke-width="2" stroke-linejoin="round"></path> <path d="M9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10Z" stroke="#93a2b8" stroke-width="2"></path> <path d="M11.6521 15C11.1982 14.2388 10.3888 14 9.00001 14C8.11946 14 7 14 7 14" stroke="#93a2b8" stroke-width="2" stroke-linecap="round"></path> <path d="M12 9L17 9" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13 12L17 12" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M15 15H17" stroke="#93a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
													</div>
												</label>
											</Col>
										</>
									)}
									<Col lg={12} className="p-0"> 
										<button
											className="button-v2 primary-theme-btn"
											style={{ width:"100%", borderRadius: "10px", fontWeight: "500", height: "50px" }}
											disabled={shouldDisableSubmit(values, errors) || isSubmitting} 
											type="submit"
											data-testid={testIds.auth.login.actions.submitButton}
										>
											Get Started {" "}
											<svg style={{ width: "15px", margin: "10px 0" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H17.5858L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289Z" fill="#ffffff"></path> </g></svg>
										</button> 
									</Col>
									<div style={{ display:"flex", gap: 10, margin: "20px auto 20px auto" }}>
										<a href="#" onClick={(e)=>{ 
											e.preventDefault();
											log("Live Chat clicked!");
											// Open Crisp live chat
											if (window.$crisp) {
												window.$crisp.push(['do', 'chat:open']);
												log("Crisp chat opened");
											} else {
												log("Crisp not loaded");
											} 
										}}>
											<div style={{ display:"flex", color: "#009cde" }}>
												<svg style={{ width:"18px", marginRight: "5px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.58584 14.3415 10.232 13.883 10.704C13.7907 10.7989 13.7027 10.8869 13.6187 10.9708C13.4029 11.1864 13.2138 11.3753 13.0479 11.5885C12.8289 11.8699 12.75 12.0768 12.75 12.25V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V12.25C11.25 11.5948 11.555 11.0644 11.8642 10.6672C12.0929 10.3733 12.3804 10.0863 12.6138 9.85346C12.6842 9.78321 12.7496 9.71789 12.807 9.65877C13.0046 9.45543 13.125 9.18004 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#009cde"></path> </g></svg>
												<p className="m-0" style={{ fontSize:"14px", fontWeight: "500" }}>Help Center</p>
											</div>
										</a>
										<div style={{ background:"#c7c7c7", width:"1.5px", margin:"auto", height:"80%" }}></div>
										
										<a 
											href="#"
											onClick={(e)=>{ 
												e.preventDefault();
												log("Live Chat clicked!");
												// Open Crisp live chat
												if (window.$crisp) {
													window.$crisp.push(['do', 'chat:open']);
													log("Crisp chat opened");
												} else {
													log("Crisp not loaded");
												} 
											}}
										>
											<div style={{ display:"flex", color: "#009cde" }}>
												<svg style={{ width:"18px", marginRight: "5px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" fill="#009cde"></path> </g></svg>
												<p className="m-0" style={{ fontSize:"14px", fontWeight: "500" }}>Contact Support</p>
											</div>
										</a>
									</div>
									{/* <Col lg={12}>
										<div className="text-center" style={{ margin: "20px auto" }}>
											<div style={{ fontSize: "14px", color: "#767a8d", fontWeight: "500" }}>
												Want to purchase a new policy? {" "}
												<span
													style={{
														color: "var(--primary-color)",
														textDecoration: "underline",
														fontWeight: "bold",
														fontSize: "14px",
													}}
													onClick={() => {
														redirect();
													}}
												>
													{" "}CLICK HERE
												</span>
											</div>
										</div>
									</Col> */}
									<Col className="p-0" lg={12}>
										<div 
											className="text-center"
											style={{
												background: "#f8fafc",
												padding: "5px",
												borderRadius: "10px"
											}}
										>    
											<svg style={{ width: "12px", margin: "0px 6px" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V10.0546C19.8648 10.1379 20.5907 10.348 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C16.867 10 16.4515 10 16 10H8C7.54849 10 7.13301 10 6.75 10.0036V8Z" fill="#8dc63f"></path> </g></svg>
											<span style={{fontSize:"12px", color:"#abb3cd"}}>Secure SSL Encrypted Connection</span>
										</div>
									</Col>
								</Row>
							</>
						)}
					</Form>
				)}
			</Formik>
		</div>
	);
}
